module.exports = __webpack_public_path__ + "static/media/Portrait-10237.d2fd832b.jpg";